'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment'));
var styledComponents = require('../styled-components.js');

var timeReporter = function (time) {
    if (time.min !== 0) {
        return '';
    }
    var timeValue = moment(time.hr + " " + time.min, 'HH mm');
    return timeValue.format('ha');
};
var TimeTableCell = function (props) {
    var interval = props.interval;
    var cellValue = timeReporter(interval);
    var startTime = { hr: 0, min: 0 };
    if (interval.hr === startTime.hr && startTime.min !== 0) {
        var isStartingInterval = interval.min === Math.floor(startTime.min / 5) * 5;
        if (isStartingInterval) {
            return React__default.createElement(styledComponents.StartingTimeTableCell, { rowSpan: 12 - Math.floor(startTime.min / 5) });
        }
    }
    if (cellValue.length > 1) {
        return (React__default.createElement(styledComponents.HourTimeTableCell, { rowSpan: 12 },
            React__default.createElement(styledComponents.PositionTime, { style: { display: interval.hr === 0 ? 'none' : 'inherit' } }, cellValue)));
    }
    return null;
};

module.exports = TimeTableCell;
